import "@/App.css";
import "@/i18n";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Layout } from "@/components/Layout";
import { AuthProvider } from "@/context/AuthContext";
import { ContentProvider } from "@/context/ContentContext";
import { AdminProtected } from "@/components/AdminProtected";
import Home from "@/pages/Home";
import Teknoloji from "@/pages/Teknoloji";
import Donanim from "@/pages/Donanim";
import Cozumler from "@/pages/Cozumler";
import NedenBiz from "@/pages/NedenBiz";
import Iletisim from "@/pages/Iletisim";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <ContentProvider>
          <BrowserRouter>
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/teknoloji" element={<Teknoloji />} />
                <Route path="/donanim" element={<Donanim />} />
                <Route path="/cozumler" element={<Cozumler />} />
                <Route path="/neden-biz" element={<NedenBiz />} />
                <Route path="/iletisim" element={<Iletisim />} />
              </Route>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin"
                element={
                  <AdminProtected>
                    <AdminDashboard />
                  </AdminProtected>
                }
              />
            </Routes>
          </BrowserRouter>
        </ContentProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
